/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { PotLifeSpecBase } from "../../../../schema/generated/PotLifeSpec";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class PotLifeSpecDataApi extends EntityDataApi<PotLifeSpecBase> {
  public readonly def = idbEntityDefs.PotLifeSpec;
}